module.exports = __webpack_public_path__ + "static/media/wrinkles_marionette.bc296ee2.svg";